export default __webpack_public_path__ + "static/media/LearningNest Green.71e46761.svg";